module.exports = "//public.zight.com/packs/media/images/icon-google-079aea4b70fd302a71f43d2967da99b2.svg";